import * as React from 'react';
export const PFSvg = React.forwardRef(function PFSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        fillRule: 'nonzero',
        d: 'M8 10a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M8 6a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 11V5h1v6h-1ZM0 5h1v6H0V5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 4v1H0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2ZM0 12v-1h16v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
    ),
  );
});
PFSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PF = {
  category: 'flag',
  colorable: false,
  name: 'PF',
  svg: PFSvg,
};
